import Cookies from 'js-cookie'
var checkLog=function (){
    if(window.localStorage.getItem("token")){
        var token=window.localStorage.getItem("token");
    }else {
        var token="";
    }
    $.ajax({
        url:URL+"/Api/Login/user_login",
        dataType:"json",
        async:true,
        data:{
            token:window.localStorage.getItem("token")
        },
        type:"POST",
        success:function(req){
            if (location.href.split("#/")[1].indexOf("personDetailsmodelone")<0&&location.href.split("#/")[1].indexOf("personDetailsmodelselect")<0){
                if(req.code==-1){
                    window.localStorage.removeItem("token");
                    mui.alert('已经在其它地方登录', '提示', function() {
                        var that=this;
                        $.ajax({
                            url:URL+"/Api/Login/logout",
                            dataType:"json",
                            async:true,
                            data:{
                                token:token
                            },
                            type:"POST",
                            success:function(req){
                                if(req.code==1){
                                    $(".mui-popup").remove();
                                    $(".mui-popup-backdrop").remove();
                                    Cookies.set('t', '',{domain: '.9hier.com'});
                                    setTimeout(function () {
                                        window.location.href="#/login";
                                    },0);
                                }
                            }
                        });
                    });
                }else if(req.code==-3){
                    window.localStorage.removeItem("token");
                    mui.alert('请重新登录', '提示', function() {
                        $(".mui-popup").remove();
                        Cookies.set('t', '',{domain: '.9hier.com'});
                        setTimeout(function () {
                            window.location.href="#/login";
                            $(".mui-popup-backdrop").remove();
                        },0);
                    });
                }else if(req.code==1&&location.href.split("#/")[1]=="login"){
                    window.location.href="#/homePage";
                }else if(req.code==1&&location.href.split("#/")[1]=="register"){
                    window.location.href="#/homePage";
                }else if (req.code==-2&&$('.mui-popup').length==0) {
                    $(".mui-popup-backdrop").removeClass("mui-active");
                }
            }
        }
    });
    function setCookie(c_name,value,expiredays) {
        var exdate=new Date();
        exdate.setDate(exdate.getDate()+expiredays);
        document.cookie=c_name+ "=" +escape(value)+
            ((expiredays==null) ? "" : ";expires="+exdate.toGMTString())
    }
    if (location.href.split("#/")[1].indexOf("personDetails")<0&&location.href.split("#/")[1].indexOf("leaveMessage")<0&&location.href.split("#/")[1].indexOf("personMessage")<0&&location.href.split("#/")[1].indexOf("editAlbum")<0) {
        setCookie('slideFlag',false,1);
        setCookie('pageFlag','intro',1);
    }
    $(".mui-backdrop").remove();
    $(".mui-dtpicker").remove();
    $(".mui-popup").remove();
    $(".mui-poppicker").remove();
};
export{
    checkLog
}


//////////////////
// WEBPACK FOOTER
// ./static/js/checkLog.js
// module id = null
// module chunks = 